import React from "react";
import logoUrl from "@/assets/encore-logo.png";

/**
 * Encore Commercial Capital logo (single-mark variant).
 *
 * The PNG is imported through the Webpack/CRA pipeline so it's emitted to
 * `/static/media/...` alongside the JS bundle. Serving it from the same
 * origin as the app means it works inside corporate networks that block
 * third-party CDNs (we previously hot-linked to customer-assets.emergent
 * and that URL was getting blocked behind some firewalls).
 */
const LOGO_URL = logoUrl;

export default function EncoreLogo({ size = 40, withWordmark = true, monochrome = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="encore-logo">
      <img
        src={LOGO_URL}
        alt="Encore Commercial Capital"
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          filter: monochrome ? "brightness(0) invert(1)" : "none",
        }}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div
            className="font-display text-[15px] font-semibold tracking-tight"
            style={{ color: monochrome ? "#fff" : "var(--ink)" }}
          >
            <span style={{ color: monochrome ? "#fff" : "#0E1525" }}>Encore</span>{" "}
            <span style={{ color: monochrome ? "#fff" : "#1F5DC6" }}>Commercial</span>
          </div>
          <div
            className="text-[10px] uppercase tracking-[0.22em]"
            style={{ color: monochrome ? "rgba(255,255,255,0.7)" : "#000" }}
          >
            Capital Corporation
          </div>
        </div>
      )}
    </div>
  );
}
